import { render, staticRenderFns } from "./societyCen.vue?vue&type=template&id=459d3dcf&scoped=true&"
import script from "./societyCen.vue?vue&type=script&lang=js&"
export * from "./societyCen.vue?vue&type=script&lang=js&"
import style1 from "./societyCen.vue?vue&type=style&index=1&id=459d3dcf&scoped=true&lang=scss&"
import style2 from "./societyCen.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d3dcf",
  null
  
)

export default component.exports